export const rhymesData = [
    {
        id: 'a-tisket-a-tasket',
        title: 'A-Tisket, A-Tasket',
        emoji: '🧺',
        color: '#FF6B6B',
        lyrics: [
            "A-tisket a-tasket,",
            "A green and yellow basket.",
            "I wrote a letter to my love,",
            "And on the way I dropped it.",
            "I dropped it, I dropped it,",
            "And on the way I dropped it.",
            "A little boy he picked it up,",
            "And put it in his pocket."
        ]
    },
    {
        id: 'baa-baa-black-sheep',
        title: 'Baa, Baa, Black Sheep',
        emoji: '🐑',
        color: '#4ECDC4',
        lyrics: [
            "Baa baa black sheep,",
            "Have you any wool?",
            "Yes sir, yes sir,",
            "Three bags full!",
            "One for the master,",
            "One for the dame,",
            "And one for the little boy",
            "Who lives down the lane."
        ]
    },
    {
        id: 'bingo',
        title: 'Bingo',
        emoji: '🐶',
        color: '#FF9F1C',
        lyrics: [
            "There was a farmer had a dog,",
            "And Bingo was his name-o.",
            "B-I-N-G-O,",
            "B-I-N-G-O,",
            "B-I-N-G-O,",
            "And Bingo was his name-o!"
        ]
    },
    {
        id: 'frere-jacques',
        title: 'Frère Jacques',
        emoji: '🔔',
        color: '#1A535C',
        lyrics: [
            "Brother John, Brother John,",
            "Are you sleeping? Are you sleeping?",
            "Morning bells are ringing!",
            "Morning bells are ringing!",
            "Ding, dang, dong.",
            "Ding, dang, dong."
        ]
    },
    {
        id: 'hey-diddle-diddle',
        title: 'Hey Diddle Diddle',
        emoji: '🎻',
        color: '#FF9F1C',
        lyrics: [
            "Hey diddle diddle,",
            "The cat and the fiddle,",
            "The cow jumped over the moon.",
            "The little dog laughed to see such fun,",
            "And the dish ran away with the spoon!"
        ]
    },
    {
        id: 'hickory-dickory-dock',
        title: 'Hickory Dickory Dock',
        emoji: '🖱️',
        color: '#2EC4B6',
        lyrics: [
            "Hickory dickory dock,",
            "The mouse ran up the clock.",
            "The clock struck one,",
            "The mouse ran down,",
            "Hickory dickory dock."
        ]
    },
    {
        id: 'humpty-dumpty',
        title: 'Humpty Dumpty',
        emoji: '🥚',
        color: '#9B5DE5',
        lyrics: [
            "Humpty Dumpty sat on a wall,",
            "Humpty Dumpty had a great fall,",
            "All the king's horses",
            "And all the king's men,",
            "Couldn't put Humpty",
            "Together again."
        ]
    },
    {
        id: 'itsy-bitsy-spider',
        title: 'Itsy Bitsy Spider',
        emoji: '🕷️',
        color: '#F15BB5',
        lyrics: [
            "The itsy bitsy spider",
            "Crawled up the water spout.",
            "Down came the rain,",
            "And washed the spider out.",
            "Out came the sun,",
            "And dried up all the rain,",
            "And the itsy bitsy spider",
            "Went up the spout again."
        ]
    },
    {
        id: 'jack-and-jill',
        title: 'Jack and Jill',
        emoji: '🪣',
        color: '#9B5DE5',
        lyrics: [
            "Jack and Jill went up the hill",
            "To fetch a pail of water.",
            "Jack fell down and broke his crown,",
            "And Jill came tumbling after."
        ]
    },
    {
        id: 'little-miss-muffet',
        title: 'Little Miss Muffet',
        emoji: '🥣',
        color: '#00BBF9',
        lyrics: [
            "Little Miss Muffet sat on a tuffet,",
            "Eating her curds and whey;",
            "Along came a spider,",
            "Who sat down beside her,",
            "And frightened Miss Muffet away!"
        ]
    },
    {
        id: 'london-bridge',
        title: 'London Bridge Is Falling Down',
        emoji: '🌉',
        color: '#00F5D4',
        lyrics: [
            "London Bridge is falling down,",
            "Falling down, falling down,",
            "London Bridge is falling down,",
            "My fair lady."
        ]
    },
    {
        id: 'mary-had-a-little-lamb',
        title: 'Mary Had a Little Lamb',
        emoji: '👧',
        color: '#FF6B6B',
        lyrics: [
            "Mary had a little lamb,",
            "Whose fleece was white as snow.",
            "And everywhere that Mary went,",
            "The lamb was sure to go.",
            "It followed her to school one day,",
            "Which was against the rule.",
            "It made the children laugh and play",
            "To see a lamb at school."
        ]
    },
    {
        id: 'old-macdonald',
        title: 'Old MacDonald Had a Farm',
        emoji: '🚜',
        color: '#4ECDC4',
        lyrics: [
            "Old MacDonald had a farm, E-I-E-I-O.",
            "And on that farm he had a cow, E-I-E-I-O.",
            "With a moo-moo here, and a moo-moo there,",
            "Here a moo, there a moo, everywhere a moo-moo.",
            "Old MacDonald had a farm, E-I-E-I-O."
        ]
    },
    {
        id: 'pat-a-cake',
        title: 'Pat-a-Cake',
        emoji: '🍰',
        color: '#F15BB5',
        lyrics: [
            "Pat-a-cake, pat-a-cake, baker's man,",
            "Bake me a cake as fast as you can;",
            "Pat it and prick it and mark it with 'B',",
            "And put it in the oven for baby and me."
        ]
    },
    {
        id: 'pop-goes-the-weasel',
        title: 'Pop Goes the Weasel',
        emoji: '🐾',
        color: '#1A535C',
        lyrics: [
            "Half a pound of tuppenny rice,",
            "Half a pound of treacle.",
            "That's the way the money goes,",
            "Pop! Goes the weasel."
        ]
    },
    {
        id: 'ring-a-ring-o-roses',
        title: "Ring-a-ring o' Roses",
        emoji: '🌹',
        color: '#FF9F1C',
        lyrics: [
            "Ring-a-ring o' roses,",
            "A pocket full of posies,",
            "A-tishoo! A-tishoo!",
            "We all fall down!"
        ]
    },
    {
        id: 'row-row-row-your-boat',
        title: 'Row, Row, Row Your Boat',
        emoji: '🚣',
        color: '#2EC4B6',
        lyrics: [
            "Row, row, row your boat,",
            "Gently down the stream.",
            "Merrily, merrily, merrily, merrily,",
            "Life is but a dream."
        ]
    },
    {
        id: 'the-muffin-man',
        title: 'The Muffin Man',
        emoji: '🧁',
        color: '#9B5DE5',
        lyrics: [
            "Oh, do you know the muffin man,",
            "The muffin man, the muffin man,",
            "Oh, do you know the muffin man,",
            "That lives on Drury Lane?"
        ]
    },
    {
        id: 'the-wheels-on-the-bus',
        title: 'The Wheels on the Bus',
        emoji: '🚌',
        color: '#F15BB5',
        lyrics: [
            "The wheels on the bus go round and round,",
            "Round and round, round and round.",
            "The wheels on the bus go round and round,",
            "All through the town."
        ]
    },
    {
        id: 'this-little-piggy',
        title: 'This Little Piggy',
        emoji: '🐷',
        color: '#4ECDC4',
        lyrics: [
            "This little piggy went to market,",
            "This little piggy stayed home,",
            "This little piggy had roast beef,",
            "This little piggy had none,",
            "And this little piggy cried 'Wee! Wee! Wee!'",
            "All the way home."
        ]
    },
    {
        id: 'twinkle-twinkle',
        title: 'Twinkle, Twinkle, Little Star',
        emoji: '⭐',
        color: '#00BBF9',
        lyrics: [
            "Twinkle, twinkle, little star,",
            "How I wonder what you are!",
            "Up above the world so high,",
            "Like a diamond in the sky.",
            "Twinkle, twinkle, little star,",
            "How I wonder what you are!"
        ]
    }
];
